export type ActionType =
  | 'SET_CROSS_SELLING_DATA'
  | 'REQUEST_CROSS_SELLING_DATA'
  | 'RECEIVED_CROSS_SELLING_DATA'
  | 'ERROR_CROSS_SELLING_DATA';

interface ActionProps {
  type: ActionType;
  isFetching?: boolean;
  data?: {} | any;
  error?: any;
  payload?: {} | any;
}

const initialState = {
  isFetching: true,
  data: {},
  error: {},
};

const CrossSelling = (state = initialState, action: Partial<ActionProps>) => {
  switch (action.type) {
    case 'REQUEST_CROSS_SELLING_DATA': {
      return {
        ...state,
      };
    }

    case 'RECEIVED_CROSS_SELLING_DATA': {
      const { payload = {} } = action;
      return {
        ...state,
        isFetching: false,
        data: { cards: [...payload] },
      };
    }

    case 'ERROR_CROSS_SELLING_DATA': {
      const { error = {} } = action;
      return {
        ...state,
        isFetching: false,
        error: { ...error },
      };
    }

    default:
      return state;
  }
};

export default CrossSelling;
